import { jsx, jsxs } from 'react/jsx-runtime';
import * as React from 'react';
import '../../utils/index_orig/index.esm.js';
import '../../utils/theme/theme-provider/index.esm.js';
import { EGDSMenuListItem } from '../menu-list-item/index.esm.js';
import { EGDSHeadingTags, defaultMenuListHeadingTag } from '../types/index.esm.js';
import styles from '../../styles/uitk-egds-menu.css';
import { classNames } from '../../utils/classnames/index.esm.js';
import { EGDSContextWrapper } from '../../utils/context-provider/index.esm.js';
const getClassNameList = classNames.bind(styles);
class EGDSMenuList extends React.Component {
  static displayName = 'EGDSMenuList';
  render() {
    const {
      children,
      items,
      title,
      allyHeadingLevel
    } = this.props;
    const HeadingLevel = allyHeadingLevel ? EGDSHeadingTags.get(allyHeadingLevel) : EGDSHeadingTags.get(defaultMenuListHeadingTag);
    return jsx(EGDSContextWrapper, {
      children: (_, data) => jsxs("div", {
        "data-testid": "egds-menu-list",
        role: data?.isInSkipLink ? undefined : 'menu',
        className: getClassNameList('uitk-list'),
        children: [title && jsx(HeadingLevel, {
          className: getClassNameList('uitk-list-title'),
          children: title
        }), items && items.map((item, index) => jsx(EGDSMenuListItem, {
          Link: item.Link,
          to: item.to,
          analytics: item.analytics,
          href: item.href,
          typeAnchor: item.typeAnchor,
          label: item.label,
          className: getClassNameList(item.className),
          role: data?.isInSkipLink ? undefined : item.attributes && item.attributes.role,
          tabIndex: item.attributes && item.attributes.tabindex,
          iconName: item.icon?.name,
          onClick: item.onClick,
          target: item.target,
          selected: item.selected,
          disabled: item.disabled,
          iconComponent: item.icon?.component
        }, index)), children]
      })
    });
  }
}
export { EGDSMenuList };